module.exports = __webpack_public_path__ + "static/media/clock.e93cc8c0.svg";